import { Client } from "@stomp/stompjs";
import { JSEncrypt } from "jsencrypt";
import moment from "moment/moment";
import {
  casinoPL,
  cricketBookMakerPL,
  cricketFancyPL,
} from "../pages/game/profitLoss";
import store from "../redux/store";
import { CSVLink } from "react-csv";
import { transformCasinoOddsDTO } from "./casinoTransformers";
export const PROD_IP = process.env.REACT_APP_API_URL;
export const DEV_IP = process.env.REACT_APP_API_URL;
export const ASSETS_URL = "https://dataobj.ecoassetsservice.com/casino-icons/lc/";
export const IS_PROD = process.env.REACT_APP_IS_PROD === "true";
const FileSaver = require("file-saver");
const XLSX = require("xlsx");
const jsPDF = require("jspdf");
var BASE_URL_;
var CRICKET_SERVICE_URL_;
var SOCCER_AND_TENNIS_SERVICE_URL_;
var CASINO_SERVICE_URL_;
var CASINO_TUNNEL_URL_;
if (IS_PROD) {
  BASE_URL_ = `https://${process.env.REACT_APP_API_URL}/aam/v1`;
  CRICKET_SERVICE_URL_ = `https://${process.env.REACT_APP_API_URL}/cm/v1`;
  SOCCER_AND_TENNIS_SERVICE_URL_ = `https://${process.env.REACT_APP_API_URL}/tas/v1`;
  CASINO_SERVICE_URL_ = `https://${process.env.REACT_APP_API_URL}/casino/v1`;
  CASINO_TUNNEL_URL_ = `https://${process.env.REACT_APP_API_URL}/tunnel/v1`;
} else {
  BASE_URL_ = `http://${process.env.REACT_APP_API_URL}:8000/api`;
  CRICKET_SERVICE_URL_ = `http://${process.env.REACT_APP_API_URL}:8001/api`;
  SOCCER_AND_TENNIS_SERVICE_URL_ = `http://${process.env.REACT_APP_API_URL}:8002/api`;
  CASINO_SERVICE_URL_ = `http://${process.env.REACT_APP_API_URL}:8003/api`;
  CASINO_TUNNEL_URL_ = `http://${process.env.REACT_APP_API_URL}:9000/api`;
}
export const BASE_URL = BASE_URL_;
export const CRICKET_SERVICE_URL = CRICKET_SERVICE_URL_;
export const SOCCER_AND_TENNIS_SERVICE_URL = SOCCER_AND_TENNIS_SERVICE_URL_;
export const CASINO_SERVICE_URL = CASINO_SERVICE_URL_;
export const CASINO_TUNNEL_URL = CASINO_TUNNEL_URL_;
export const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQB0ZacT13Ok+3pX0lmuJ9dJ
F6atV7Vwv5gmgpvXiBVYKKM4sfGb2qg395uVcampRgLrM63KxElPkWaa90j10ol6
fnHneE3sGuNIrvUmSvtqgeSD8nS4GXdkDecD+HSB7OCOcr+oxsGZzXJdzN/5QyUd
DGpRTlm8T+yB6wa9sJPPgZJ/C650JF57WF+G3qSngqJZEtGrKLlZYL24AqVEg85d
gLsrawWpZUEGeYqhYsdSeoGqkAR6E8Ybw+YWEYCFyMLZi2Fe5MVwMARWQ5kzpKTx
0ur7DPsghrAem08DIAekAN97F1DS48Vs88T29C2716ylE27ICyiMLDw9DLXekhAD
AgMBAAE=
-----END PUBLIC KEY-----`;
export const buttonColors = "#827908";
export const blueColor = "#007bff";
export const bgColor = "#eee";
export const secondaryColor = "#f5f5f5";
export const casinoBgColor = "#ffffff";
export const applyFancyFor = [
  "Over By Over",
  "Normal",
  "Ball By Ball",
  "meter",
  // "fancy1",
  // "oddeven",
];
export const sortByStringNumberInEnd = (a, b) => {
  const aNumber = parseInt(a);
  const bNumber = parseInt(b);
  if (aNumber && bNumber) {
    return aNumber - bNumber;
  } else if (aNumber) {
    return -1;
  } else if (bNumber) {
    return 1;
  } else {
    return a.localeCompare(b);
  }
};
var ENCRYPT = new JSEncrypt();
ENCRYPT.setPublicKey(PUBLIC_KEY);
export const Encrypt = (data) => ENCRYPT.encrypt(data);
export const getToken = () => {
  return store.getState().account.userData.token;
};
export const getCurrentDateTimeLocal = (
  prev = false,
  date_ = false,
  time = false
) => {
  let date = new Date(); // create a new Date object with the current date and time
  let year = date.getFullYear(); // get the four-digit year (e.g. 2026)
  let month = ("0" + (date.getMonth() + 1)).slice(-2); // get the month as a zero-padded two-digit string (e.g. "03")
  let day = ("0" + date.getDate()).slice(-2); // get the day of the month as a zero-padded two-digit string (e.g. "04")
  /*  let hour = ("0" + date.getHours()).slice(-2); // get the hour as a zero-padded two-digit string (e.g. "09")
  let minute = ("0" + date.getMinutes()).slice(-2); // get the minute as a zero-padded two-digit string (e.g. "05") */
  if (prev) {
    if (date_) {
      day = ("0" + (date.getDate() - date_)).slice(-2);
    } else {
      day = ("0" + (date.getDate() - 1)).slice(-2);
    }
  }
  let formattedDate = `${day}-${month}-${year}`; // concatenate the year, month, and day with hyphens as the separator
  return formattedDate;
};

export const convertEpochToDate = (epoch) => {
  return moment.utc(epoch).local().format("DD/MM/YYYY hh:mm A");
};
export function searchSubstringInArrayObjects(array, keys, searchString) {
  return array.filter((obj) => {
    return keys.some((key) => {
      if (!obj[key]) return false;
      return String(obj[key])
        .toLowerCase()
        .includes(searchString.toLowerCase());
    });
  });
}
export const getProfit = (selectedAmount, game, selectedEventForBet) => {
  let profit;
  let loss;
  let selectedAmount_ = selectedEventForBet.amount;
  if (game == "cricket" && selectedEventForBet.isBookmaker) {
    profit = cricketBookMakerPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).profit;
    loss = cricketBookMakerPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).loss;
  } else if (game == "casino" || game == "tennis" || game == "soccer") {
    profit = casinoPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).profit;
    loss = casinoPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).loss;
  } else if (game == "cricket" && selectedEventForBet.isFancy) {
    profit = cricketFancyPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).profit;
    loss = cricketFancyPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).loss;
  } else {
    profit = casinoPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).profit;
    loss = casinoPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).loss;
  }
  return {
    profit: parseFloat(profit).toFixed(2),
    loss: parseFloat(loss).toFixed(2),
  };
};

const CASINO_ODDS_ACTION_MAP = {
  dragonTiger20: "gameData/setDragonTiger20Odds",
  casinoMeter: "gameData/setCasinoMeterOdds",
  teenPatti20: "gameData/setTeenPatti20Odds",
  dragonTiger202: "gameData/setDragonTiger202Odds",
  lucky7: "gameData/setLucky7Odds",
  lucky7eu: "gameData/setLucky7euOdds",
  casinoQueen: "gameData/setCasinoQueenOdds",
  aaa: "gameData/setAaaOdds",
  poker20: "gameData/setPoker20Odds",
  dragonTigerOneDay: "gameData/setDragonTigerOneDayOdds",
  teen: "gameData/setTeenOdds",
  andarBahar20: "gameData/setAndarBahar20Odds",
  abj: "gameData/setAbjOdds",
  card32: "gameData/setCard32Odds",
  dragonTigerLion: "gameData/setDragonTigerLionOdds",
  teen8: "gameData/setTeen8Odds",
  teen9: "gameData/setTeen9Odds",
  teen62: "gameData/setTeen62Odds",
  dolidana: "gameData/setDolidanaOdds",
  mogambo: "gameData/setMogamboOdds",
  lucky5: "gameData/setLucky5Odds",
  roulette12: "gameData/setRoulette12Odds",
  roulette13: "gameData/setRoulette13Odds",
  roulette11: "gameData/setRoulette11Odds",
  poison: "gameData/setPoisonOdds",
  poison20: "gameData/setPoison20Odds",
  joker120: "gameData/setJoker120Odds",
  joker20: "gameData/setJoker20Odds",
  joker1: "gameData/setJoker1Odds",
  teen20c: "gameData/setTeen20cOdds",
  btable2: "gameData/setBtable2Odds",
  teenunique: "gameData/setTeenUniqueOdds",
  ourroullete: "gameData/setOurRouletteOdds",
  poker9: "gameData/setPoker9Odds",
  card32eu: "gameData/setCard32euOdds",
  baccarat2: "gameData/setBaccarat20Odds",
  race20: "gameData/setRace20Odds",
  worli2: "gameData/setWorli2Odds",
  bollywoodTable: "gameData/setBollywoodTableOdds",
  casinoWar: "gameData/setCasinoWarOdds",
  baccarat: "gameData/setBaccaratOdds",
  cmatch20: "gameData/setCmatch20Odds",
  worli: "gameData/setWorliOdds",
  superOver: "gameData/setSuperOverOdds",
  superover3: "gameData/setSuperOver3Odds",
  goal: "gameData/setGoalOdds",
  cricketV3: "gameData/setCricketv3Odds",
  ab4: "gameData/setAb4Odds",
  lucky15: "gameData/setLucky15Odds",
};

export const createSocket = (id, dispatch, game = "dragonTiger20") => {
  const stompURL =
    id == "cricket"
      ? !IS_PROD
        ? CRICKET_SERVICE_URL.replace("http", "ws").replace("/api", "/websocket")
        : CRICKET_SERVICE_URL.replace("http", "ws").replace("/v1", "") + "/websocket"
      : id == "casino"
      ? !IS_PROD
        ? CASINO_SERVICE_URL.replace("http", "ws").replace("/api", "/websocket")
        : CASINO_SERVICE_URL.replace("http", "ws").replace("/v1", "") + "/websocket"
      : !IS_PROD
      ? SOCCER_AND_TENNIS_SERVICE_URL.replace("http", "ws").replace("/api", "/websocket")
      : SOCCER_AND_TENNIS_SERVICE_URL.replace("http", "ws").replace("/v1", "") + "/websocket";

  dispatch({ type: "accountData/setLoading", payload: true });

  const client = new Client({
    brokerURL: stompURL,
    reconnectDelay: 3000,
    debug: () => null,
    onConnect: () => {
      dispatch({ type: "accountData/setLoading", payload: false });

      if (id != "casino") {
        client.subscribe("/live/liveMatches", function (message) {
          try {
            let data = JSON.parse(message.body);
            if (id == "cricket")
              dispatch({ type: "gameData/mergeCricketGames", payload: data });
            if (id == "soccer" || id == "tennis") {
              dispatch({
                type: "gameData/mergeSoccerGames",
                payload: data.soccerAllMatchesResponseDTOS,
              });
              dispatch({
                type: "gameData/mergeTennisGames",
                payload: data.tennisAllMatchesResponseDTOS,
              });
            }
          } catch (e) {}
        });
      }

      let url = "";
      if (id == "cricket") url = "/live/liveOdds";
      if (id == "soccer") url = "/live/soccer/liveOdds";
      if (id == "tennis") url = "/live/tennis/liveOdds";
      if (id == "casino") url = `/live/${game}`;

      client.subscribe(url, function (message) {
        try {
          const data = JSON.parse(message.body);
          if (id == "cricket") {
            dispatch({ type: "gameData/setCricketOdds", payload: data });
          } else if (id == "soccer") {
            dispatch({ type: "gameData/setSoccerOdds", payload: data });
          } else if (id == "tennis") {
            dispatch({ type: "gameData/setTennisOdds", payload: data });
          } else if (id == "casino") {
            const actionType = CASINO_ODDS_ACTION_MAP[game];
            if (actionType) {
              const transformedData = transformCasinoOddsDTO(data);
              dispatch({ type: actionType, payload: transformedData });
            }
            dispatch({ type: "accountData/setLoading", payload: false });
          }
        } catch (e) {}
      });
    },
    onStompError: (frame) => {
      console.error("[createSocket] STOMP error for", id, ":", frame.headers["message"]);
      dispatch({ type: "accountData/setLoading", payload: false });
    },
    onWebSocketClose: () => {
      console.warn("[createSocket] WebSocket closed for", id, "— will auto-reconnect");
    },
  });

  client.activate();
  return client;
};
export const updateReduxToken = (token) => (dispatch) => {
  dispatch({
    type: "accountData/setToken",
    payload: token,
  });
};

export const exportToCsvReactCsv = (csvData, fileName) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const data = csvData;
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data1 = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data1, fileName + fileExtension);
};

export const exportToPdf = (component) => {
  const doc = new jsPDF.jsPDF();
  doc.html(document.querySelector("#" + component), {
    callback: function (pdf) {
      pdf.save(component + ".pdf");
    },
  });
};

export const CASINO_CDN = "https://dataobj.ecoassetsservice.com/casino-icons/lc/";
export const CASINO_DEFAULT = "https://dataobj.ecoassetsservice.com/casino-icons/default.jpg";
export const casinoGameList = [
  { name: "Matka", url: "worli3.gif", path: "worli3", group: "matka" },
  { name: "V VIP Teenpatti 1-day", url: "teen62.gif", path: "teen62", group: "teenpatti" },
  { name: "Dolidana", url: "dolidana.gif", path: "dolidana", group: "casino" },
  { name: "Mogambo", url: "mogambo.gif", path: "mogambo", group: "casino" },
  { name: "20-20 Teenpatti VIP1", url: "teen20v1.jpg", path: "teen20v1", group: "teenpatti" },
  { name: "Lucky 6", url: "lucky5.jpg", path: "lucky5", group: "lucky" },
  { name: "Beach Roulette", url: "roulette12.jpg", path: "roulette12", group: "casino" },
  { name: "Roulette", url: "roulette13.jpg", path: "roulette13", group: "casino" },
  { name: "Golden Roulette", url: "roulette11.jpg", path: "roulette11", group: "casino" },
  { name: "Teenpatti Poison One Day", url: "poison.jpg", path: "poison", group: "teenpatti" },
  { name: "Unique Teenpatti", url: "teenunique.jpg", path: "teenunique", group: "teenpatti" },
  { name: "Teenpatti Poison 20-20", url: "poison20.jpg", path: "poison20", group: "teenpatti" },
  { name: "Unlimited Joker 20-20", url: "joker120.jpg", path: "joker120", group: "casino" },
  { name: "Teenpatti Joker 20-20", url: "joker20.jpg", path: "joker20", group: "teenpatti" },
  { name: "Unlimited Joker Oneday", url: "joker1.jpg", path: "joker1", group: "casino" },
  { name: "20-20 Teenpatti C", url: "teen20c.jpg", path: "teen20c", group: "teenpatti" },
  { name: "Bollywood Casino 2", url: "btable2.jpg", path: "btable2", group: "bollywood" },
  { name: "Unique Roulette", url: "ourroullete.jpg", path: "ourroullete", group: "casino" },
  { name: "Mini Superover", url: "superover3.jpg", path: "superover3", group: "sports-casino" },
  { name: "Goal", url: "goal.jpg", path: "goal", group: "sports-casino" },
  { name: "Andar Bahar 150 Cards", url: "ab4.jpg", path: "ab4", group: "andar-bahar" },
  { name: "Lucky 15", url: "lucky15.jpg", path: "lucky15", group: "lucky" },
  { name: "Super Over 2", url: "superover2.jpg", path: "superover2", group: "sports-casino" },
  { name: "Queen Top Open Teenpatti", url: "teen41.jpg", path: "teen41", group: "teenpatti" },
  { name: "Jack Top Open Teenpatti", url: "teen42.jpg", path: "teen42", group: "teenpatti" },
  { name: "Sic Bo 2", url: "sicbo2.jpg", path: "sicbo2", group: "casino" },
  { name: "Instant Teenpatti 3.0", url: "teen33.jpg", path: "teen33", group: "teenpatti" },
  { name: "Sic Bo", url: "sicbo.jpg", path: "sicbo", group: "casino" },
  { name: "Ball by Ball", url: "ballbyball.jpg", path: "ballbyball", group: "sports-casino" },
  { name: "Instant Teenpatti 2.0", url: "teen32.jpg", path: "teen32", group: "teenpatti" },
  { name: "Teenpatti 1-day", url: "teen.jpg", path: "teen", group: "teenpatti" },
  { name: "20-20 Teenpatti", url: "teen20.jpg", path: "teenPatti20", group: "teenpatti" },
  { name: "Teenpatti Test", url: "teen9.jpg", path: "teen9", group: "teenpatti" },
  { name: "Teenpatti Open", url: "teen8.jpg", path: "teen8", group: "teenpatti" },
  { name: "Poker 1-Day", url: "poker.jpg", path: "poker", group: "poker" },
  { name: "20-20 Poker", url: "poker20.jpg", path: "poker20", group: "poker" },
  { name: "Poker 6 Players", url: "poker6.jpg", path: "poker9", group: "poker" },
  { name: "Baccarat", url: "baccarat.jpg", path: "baccarat", group: "baccarat" },
  { name: "Baccarat 2", url: "baccarat2.jpg", path: "baccarat2", group: "baccarat" },
  { name: "20-20 Dragon Tiger", url: "dt20.jpg", path: "dragonTiger202", group: "dragon-tiger" },
  { name: "1 Day Dragon Tiger", url: "dt6.jpg", path: "dragonTigerOneDay", group: "dragon-tiger" },
  { name: "20-20 D T L", url: "dtl20.jpg", path: "dragonTigerLion", group: "dragon-tiger" },
  { name: "20-20 Dragon Tiger 2", url: "dt202.jpg", path: "dragonTiger20", group: "dragon-tiger" },
  { name: "32 Cards A", url: "card32.jpg", path: "card32", group: "32-cards" },
  { name: "32 Cards B", url: "card32eu.jpg", path: "card32eu", group: "32-cards" },
  { name: "Andar Bahar", url: "ab20.jpg", path: "andarBahar20", group: "andar-bahar" },
  { name: "Andar Bahar 2", url: "abj.jpg", path: "abj", group: "andar-bahar" },
  { name: "Lucky 7 - A", url: "lucky7.jpg", path: "lucky7", group: "lucky" },
  { name: "Lucky 7 - B", url: "lucky7eu.jpg", path: "lucky7eu", group: "lucky" },
  { name: "3 Cards Judgement", url: "3cardj.jpg", path: "3cardsjudgement", group: "casino" },
  { name: "Casino War", url: "war.jpg", path: "casinoWar", group: "casino" },
  { name: "Worli Matka", url: "worli.jpg", path: "worli", group: "worli" },
  { name: "Instant Worli", url: "worli2.jpg", path: "worli2", group: "worli" },
  { name: "Amar Akbar Anthony", url: "aaa.jpg", path: "aaa", group: "bollywood" },
  { name: "Bollywood Casino", url: "btable.jpg", path: "bollywoodTable", group: "bollywood" },
  { name: "Lottery", url: "lottcard.jpg", path: "lottcard", group: "lottery" },
  { name: "5Five Cricket", url: "cricketv3.jpg", path: "cricketV3", group: "sports-casino" },
  { name: "Cricket Match 20-20", url: "cmatch20.jpg", path: "cmatch20", group: "sports-casino" },
  { name: "Casino Meter", url: "cmeter.jpg", path: "casinoMeter", group: "sports-casino" },
  { name: "Teenpatti - 2.0", url: "teen6.jpg", path: "teen6", group: "teenpatti" },
  { name: "Queen", url: "queen.jpg", path: "casinoQueen", group: "casino" },
  { name: "Race 20", url: "race20.jpg", path: "race20", group: "race" },
  { name: "Lucky 7 - C", url: "lucky7eu2.jpg", path: "lucky7eu2", group: "lucky" },
  { name: "Super Over", url: "superover.jpg", path: "superOver", group: "sports-casino" },
  { name: "The Trap", url: "trap.jpg", path: "trap", group: "casino" },
  { name: "2 Cards Teenpatti", url: "patti2.jpg", path: "patti2", group: "teenpatti" },
  { name: "29Card Baccarat", url: "teensin.jpg", path: "teensin", group: "baccarat" },
  { name: "Muflis Teenpatti", url: "teenmuf.jpg", path: "teenmuf", group: "teenpatti" },
  { name: "Race To 17", url: "race17.jpg", path: "race17", group: "race" },
  { name: "20-20 Teenpatti B", url: "teen20b.jpg", path: "teen20b", group: "teenpatti" },
  { name: "Trio", url: "trio.jpg", path: "trio", group: "casino" },
  { name: "Note Number", url: "notenum.jpg", path: "notenum", group: "casino" },
  { name: "1 Card 20-20", url: "teen120.jpg", path: "teen120", group: "casino" },
  { name: "1 Card One-Day", url: "teen1.jpg", path: "teen1", group: "casino" },
  { name: "Andar Bahar 50 Cards", url: "ab3.jpg", path: "ab3", group: "andar-bahar" },
  { name: "Amar Akbar Anthony 2", url: "aaa2.jpg", path: "aaa2", group: "bollywood" },
  { name: "Race to 2nd", url: "race2.jpg", path: "race2", group: "race" },
  { name: "Instant Teenpatti", url: "teen3.jpg", path: "teen3", group: "teenpatti" },
  { name: "Dus ka Dum", url: "dum10.jpg", path: "dum10", group: "casino" },
  { name: "1 Card Meter", url: "cmeter1.jpg", path: "cmeter1", group: "sports-casino" },
];
export const pokerGameList = casinoGameList;
export const CASINO_AVAILABLE_PATHS = new Set([
  "dragonTiger202",
  "teenPatti20", "card32", "card32eu", "race20",
  "casinoQueen", "dragonTiger20", "dragonTigerOneDay", "lucky7", "lucky7eu",
  "andarBahar20", "abj", "3cardsjudgement", "bollywoodTable", "aaa",
  "teen", "poker20", "worli2", "casinoMeter", "dragonTigerLion",
  "teen9", "teen8", "casinoWar", "cricketV3", "cmatch20", "mogambo", "lucky5",
  "roulette12", "roulette13", "roulette11", "ourroullete", "poison", "poison20", "joker120", "joker20", "joker1", "teen20c", "btable2", "teenunique",
  "poker", "poker9", "baccarat", "baccarat2", "worli", "superOver", "superover3", "goal", "ab4", "lucky15",
  "teen62", "dolidana",
]);
export const sidebarCasinoList = [
  { name: "Our Casino", link: "/live-casino", blink: true },
  { name: "Our VIP Casino", pending: true, blink: true },
  { name: "Our Premium Casino", pending: true, blink: true },
  { name: "Our Virtual", pending: true, blink: true },
  { name: "Tembo", pending: true },
  { name: "Live Casino", link: "/live-casino" },
  { name: "Slot Game", link: "/slots" },
  { name: "Fantasy Game", link: "/fantasy" },
];
